import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { LoteMadeira } from '../../types/aquisicao';
import {
  fornecedoresService,
  lotesMadeiraService,
  produtosService,
  unidadesMedidaService,
} from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<LoteMadeira>[] = [
  {
    name: 'entidade',
    label: 'Fornecedor',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      fornecedoresService.list,
      (item: any) => item.razao_social ?? item.nome_fantasia ?? String(item.id),
    ),
    required: true,
    showSearchControl: false,
  },
  {
    name: 'produto',
    label: 'Produto',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      produtosService.list,
      (item: any) => `${item.codigo} - ${item.descricao}`,
    ),
    required: true,
    showSearchControl: false,
  },
  {
    name: 'data_recebimento',
    label: 'Data de Recebimento',
    type: 'date',
    required: true,
  },
  {
    name: 'volume_entrada',
    label: 'Volume de Entrada (m³)',
    type: 'number',
    placeholder: '0.00',
    required: true,
  },
  {
    name: 'peso_entrada',
    label: 'Peso de Entrada (ton)',
    type: 'number',
    placeholder: '0.00',
    required: true,
  },
  {
    name: 'umidade_entrada',
    label: 'Umidade na Entrada (%)',
    type: 'number',
    placeholder: '0.0',
    helperText: 'Percentual de umidade medido no recebimento',
  },
  {
    name: 'unidade_medida',
    label: 'Unidade de Medida',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      unidadesMedidaService.list,
      (item: any) => `${item.codigo} - ${item.descricao}`,
    ),
    required: true,
    showSearchControl: false,
  },
  {
    name: 'status_tratamento',
    label: 'Status do Tratamento',
    type: 'select',
    options: [
      { label: 'Pendente', value: 'PENDENTE' },
      { label: 'Em Tratamento', value: 'EM_TRATAMENTO' },
      { label: 'Concluído', value: 'CONCLUIDO' },
      { label: 'Reprovado', value: 'REPROVADO' },
    ],
    required: true,
  },
  {
    name: 'observacoes',
    label: 'Observações',
    type: 'textarea',
    placeholder: 'Informações adicionais sobre o lote...',
  },
];

export const LotesMadeiraFormPage: React.FC = () => (
  <ResourceFormPage
    title="Lote de Madeira"
    service={lotesMadeiraService}
    fields={fields}
    redirectPath="/admin/producao/lotes-madeira"
    cancelPath="/admin/producao/lotes-madeira"
  />
);
